import { baseApiV2 } from '@verantos-dev/app-state-base';
import { getProjectsBasePath } from '@verantos-dev/core-constants';
import { type CohortSummaryDetails } from '@verantos-dev/types-cohorts';
import { type ObjectResponse } from '@verantos-dev/types-common';

export const datasetApiSlice = baseApiV2
  .enhanceEndpoints({
    addTagTypes: ['cohortSummary'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCohortSummaryByCohortProfileId: builder.query<
        ObjectResponse<CohortSummaryDetails>,
        { projectId: string; cohortProfileId: string }
      >({
        query: ({ projectId, cohortProfileId }) =>
          `${getProjectsBasePath()}/${projectId}/cohort-profile/${cohortProfileId}/summary`,
        providesTags: (result, error, { cohortProfileId }) => [
          { type: 'cohortSummary', id: cohortProfileId },
        ],
      }),
    }),
  });

export const {
  useGetCohortSummaryByCohortProfileIdQuery,
  useLazyGetCohortSummaryByCohortProfileIdQuery,
} = datasetApiSlice;
